import JobsList from ".";
import ManageJob from "../../../../../components/sections/admin/Job/ManageJob";
import JobApplication from "../JobApplication";
import JobDepartment from "../JobDepartment";
import JobCategory from "../JobCategory";
import JobExperience from "../JobExperience";
import JobSkill from "../JobSkill";
import TabsNavigation from "../../../../../components/elements/TabsNavigation";
import JobQualification from "../JobQualification";
import JobSalaryRange from "../JobSalaryRange";

const tabRoutes = [
  {
    label: "List",
    icon: "fa-regular fa-list",
    path: "/admin/jobs",
  },
  {
    label: "Applications",
    icon: "fa-regular fa-paper-plane",
    path: "/admin/job-applications",
  },
  {
    label: "Departments",
    icon: "fa-regular fa-sitemap",
    path: "/admin/job-departments",
  },
  {
    label: "Categories",
    icon: "fa-regular fa-layer-group",
    path: "/admin/job-categories",
  },
  { label: "Skills", icon: "fa-regular fa-lightbulb", path: "/admin/job-skills" },
  { label: "Experiences", icon: "fa-regular fa-chart-line", path: "/admin/job-experiences" },
  { label: "Qualifications", icon: "fa-solid fa-award", path: "/admin/job-qualifications" },
  { label: "Salary Range", icon: "fas fa-money-bill-wave", path: "/admin/job-salaryRange" },
];

export const jobsRoutes = () => [
  {
    path: "/admin/jobs",
    component: () => (
      <TabsNavigation title="Career Management" tabRoutes={tabRoutes}>
        <JobsList />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Jobs List",
  },
  {
    path: "/admin/job-applications",
    component: () => (
      <TabsNavigation title="Career Management" tabRoutes={tabRoutes}>
        <JobApplication />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Jobs Applications",
  },
  {
    path: "/admin/job-departments",
    component: () => (
      <TabsNavigation title="Career Management" tabRoutes={tabRoutes}>
        <JobDepartment />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Jobs Departments",
  },
  {
    path: "/admin/job-categories",
    component: () => (
      <TabsNavigation title="Career Management" tabRoutes={tabRoutes}>
        <JobCategory />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Jobs Categories",
  },
  {
    path: "/admin/job-skills",
    component: () => (
      <TabsNavigation title="Career Management" tabRoutes={tabRoutes}>
        <JobSkill />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Jobs Skills",
  },
  {
    path: "/admin/job-experiences",
    component: () => (
      <TabsNavigation title="Career Management" tabRoutes={tabRoutes}>
        <JobExperience />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Jobs Departments",
  },
  {
    path: "/admin/job-qualifications",
    component: () => (
      <TabsNavigation title="Career Management" tabRoutes={tabRoutes}>
        <JobQualification />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Jobs Departments",
  },
  {
    path: "/admin/job-salaryRange",
    component: () => (
      <TabsNavigation title="Career Management" tabRoutes={tabRoutes}>
        <JobSalaryRange />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Jobs Departments",
  },
  {
    path: "/admin/manage-jobs",
    component: ManageJob,
    layout: "admin",
    routeType: "admin",
    title: "Manage Jobs",
  },
  {
    path: `/admin/manage-jobs/:id`,
    component: ManageJob,
    layout: "admin",
    routeType: "admin",
    title: "Manage Jobs",
  },
];
